import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, Container, Row } from '../../../Shared/Grid'
import { withTranslation } from 'react-i18next'
import Button from '../../../Shared/Form/Button'
import { nodeIdsAddInfo, tagIds2NodeIds, tags } from './dataEditImageInformation'
import CheckboxTree from 'react-checkbox-tree'
import Pill from '../../../Shared/Pill'
import Loader from '../../../Shared/Loader'
import Alert from '../../../Shared/Alert'
import { patchImage } from '../../../../api'
import Icon from '../../../Shared/Icon'
import InputTracked from '../../../Shared/FormTracked/InputTracked'
import activityTrackingService from '../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../constants'
import Select from '../../../Shared/Form/Select'

class EditImageInformation extends Component {

  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      error: false,
      caption: '',
      keyword: '',
      photographer: '',
      copyright: '',
      checked: [],
      expanded: [],
      primaryTag: null
    }
  }

  componentDidMount () {
    this.updateFromProps()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.image !== this.props.image) {
      this.updateFromProps()
    }
  }

  onInputChange = (key, v) => {
    const m = {}
    m[key] = v
    this.setState(m)
  }

  onSave = () => {
    activityTrackingService.trackEvent(trackingEvent.saveImageInfo)
    this.setState({ loading: true, error: false }, () => {
      const info = {
        caption: { 'en_GB': this.state.caption },
        keyword: this.state.keyword,
        photographer: this.state.photographer,
        copyright: this.state.copyright,
        tags: []
      }
      for (let i = 0; i < this.state.checked.length; i++) {
        let tag = {
          id: parseInt(this.state.checked[i], 10),
          isPrimary: false
        }
        if (parseInt(this.state.checked[i], 10) === parseInt(this.state.primaryTag, 10)) {
          tag.isPrimary = true
        }
        info.tags.push(tag)
      }
      const { fetchPromise } = patchImage(this.props.image.giataId, this.props.image.id,
        { info: info })
      fetchPromise.then(() => {
        const image = { ...this.props.image }
        image.info = info
        this.props.onImageChanged(image)
        this.setState({ loading: false })
        this.props.onSave && this.props.onSave()
      }).catch(() => {
        this.setState({ loading: false, error: true })
      })
    })
  }

  onTagCheck = (checkedNodeIds, targetNode) => {
    if (targetNode.checked === false) {
      this.onTagRemoved(checkedNodeIds, targetNode.value)
    } else {
      this.onTagAdded(checkedNodeIds, targetNode)
    }
  }

  getTagNameByNodeId (nodeId) {
    return nodeIdsAddInfo.hasOwnProperty(nodeId) ? nodeIdsAddInfo[nodeId].label : ''
  }

  onTagAdded = (checkedNodeIds, targetNode) => {
    activityTrackingService.trackEvent(trackingEvent.addTag, {
      name: this.getTagNameByNodeId(targetNode.value)
    })
    let additionalTagsToAdd = []
    if (nodeIdsAddInfo.hasOwnProperty(targetNode.value)) {
      additionalTagsToAdd = nodeIdsAddInfo[targetNode.value].autoSelectTagIds.split(',')
    }
    let alreadyAddedMap = {}

    // create already added tag map
    for (let checkedNodeId of checkedNodeIds) {
      alreadyAddedMap[checkedNodeId] = 1
    }
    // add additionalTagsToAdd
    for (let tagId of additionalTagsToAdd) {
      if (!tagIds2NodeIds.hasOwnProperty(tagId) || alreadyAddedMap.hasOwnProperty(tagIds2NodeIds[tagId])) {
        continue
      }
      checkedNodeIds.push(tagIds2NodeIds[tagId])
    }
    // Add primary if primary not yet selected
    if (this.state.primaryTag === null) {
      this.setState({ primaryTag: targetNode.value })
    }
    this.setState({ checked: checkedNodeIds })
  }
  onTagRemoved = (checkedNodeIds, removedNodeId) => {
    let primary = this.state.primaryTag
    if (primary === removedNodeId) {
      primary = null
    }
    if (primary === null && checkedNodeIds.length > 0) {
      primary = checkedNodeIds[0]
    }
    this.setState({ checked: checkedNodeIds, primaryTag: primary })
  }

  updateFromProps = () => {
    const tags = []
    let primaryTag = null
    let caption = ''
    let photographer = ''
    let keyword = ''
    let copyright = ''

    if (this.props.image.hasOwnProperty('info') && this.props.image.info !== null
    ) {
      // Tags
      if (this.props.image.info.hasOwnProperty('tags') && Array.isArray(this.props.image.info.tags)) {
        for (let i = 0; i < this.props.image.info.tags.length; i++) {
          let tagNodeId = this.props.image.info.tags[i].id
          let isPrimary = this.props.image.info.tags[i].isPrimary === true
          tags.push(tagNodeId)
          if (isPrimary) {
            primaryTag = tagNodeId
          }
        }
      }
      // Other
      if (this.props.image.info.hasOwnProperty('caption')) {
        if (this.props.image.info.caption.hasOwnProperty('en_GB')) {
          caption = this.props.image.info.caption.en_GB
        }
      }
      if (this.props.image.info.hasOwnProperty('keyword')) {
        keyword = this.props.image.info.keyword
      }
      if (this.props.image.info.hasOwnProperty('photographer')) {
        photographer = this.props.image.info.photographer
      }
      if (this.props.image.info.hasOwnProperty('copyright')) {
        copyright = this.props.image.info.copyright
      }
    }
    this.setState({
      checked: tags,
      expanded: [],
      primaryTag,
      copyright,
      keyword,
      photographer,
      caption
    })
  }

  onPrimaryTagChange = (e) => {
    activityTrackingService.trackEvent(trackingEvent.selectPrimaryTag, {
      name: this.getTagNameByNodeId(e.target.value)
    })
    this.setState({ primaryTag: e.target.value })
  }

  onTagPillClick (nodeId) {
    this.onTagRemoved(this.state.checked.filter((n) => {
      return n !== nodeId
    }, nodeId), nodeId)
  }

  render () {
    const { t } = this.props
    const primaryTagOptions = []
    for (const checkedNodeId of this.state.checked) {
      primaryTagOptions.push({
        value: checkedNodeId,
        label: nodeIdsAddInfo[checkedNodeId].label
      })
    }
    const eventName = trackingEvent.editImageInfoField

    return (
      <Container gutterWidth={5}>
        {this.state.loading && <Loader size={32}/>}
        <Row style={{ marginBottom: '15px' }}>
          <h3>{t('EDIT_IMAGE_INFORMATION')}</h3>
        </Row>
        <Row>
          <Col xs={12} lg={6}>
            <InputTracked
              eventName={eventName}
              eventOpts={{ field: 'Caption' }}
              onChange={(e) => {this.onInputChange('caption', e.target.value)}} value={this.state.caption}
              label={t('CAPTION')}/>
          </Col>
          <Col xs={12} lg={6}>
            <InputTracked
              eventName={eventName}
              eventOpts={{ field: 'Keyword' }}
              onChange={(e) => {this.onInputChange('keyword', e.target.value)}}
              value={this.state.keyword}
              label={t('KEYWORD')}/>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6}>
            <InputTracked
              eventName={eventName}
              eventOpts={{ field: 'Photographer' }}
              onChange={(e) => {this.onInputChange('photographer', e.target.value)}}
              value={this.state.photographer} label={t('PHOTOGRAPHER')}/>
          </Col>
          <Col xs={12} lg={6}>
            <InputTracked
              eventName={eventName}
              eventOpts={{ field: 'Copyright' }}
              onChange={(e) => {this.onInputChange('copyright', e.target.value)}} value={this.state.copyright}
              label={t('COPYRIGHT')}/>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <label>Tags</label>
            {this.state.checked.length > 0 &&
              <div>
                {
                  this.state.checked.map((nodeId) => {
                    return <Pill
                      key={nodeId}
                      onClick={() => this.onTagPillClick(nodeId)}
                      type="blue">
                      <div style={{ display: 'flex' }}>
                        <span>{nodeIdsAddInfo[nodeId].label}</span>
                        <Icon type={'im'} imClassName={'im-minus'}/>
                      </div>
                    </Pill>
                  })
                }
              </div>
            }
            <CheckboxTree
              nodes={tags}
              checked={this.state.checked}
              expanded={this.state.expanded}
              onExpand={expanded => this.setState({ expanded })}
              onCheck={this.onTagCheck}
              onlyLeafCheckboxes
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Select
              label={'Primary Tag'} onChange={this.onPrimaryTagChange} selected={this.state.primaryTag} options={
              primaryTagOptions
            }/>
          </Col>
        </Row>
        {this.state.error &&
          <Alert type={'danger'}>Failed to save. Error occurred</Alert>
        }
        <Row>
          <Col xs={12}><Button onClick={this.onSave}>{t('BUTTON_SAVE')}</Button></Col>
        </Row>
      </Container>
    )
  }
}

EditImageInformation.propTypes = {
  image: PropTypes.object.isRequired,
  onSave: PropTypes.func,
}

export default withTranslation()(EditImageInformation)
